angular.module('tgaAdmin').controller('BannerCreateOrUpdateController', [
  'bannerNotificationsService',
  '$scope',
  '$state',
  'tzService',
  'userService',
  '$translate',
  '$timeout',
  function (bannerNotificationsService, $scope, $state, tzService, userService, $translate, $timeout) {
    $scope.banner_id = $state.params.banner_id || null;
    $scope.loading = false;
    $scope.processing = false;

    $scope.themes = ['info', 'warning', 'danger'];

    $scope.domains = [];

    $scope.formData = {
      start_date: null,
      end_date: null,
      message: null,
      theme: 'info',
      subdomains: [],
      dismissible: false,
      is_global: true,
    };

    $scope.initialize = () => {
      const user = userService.getUserData();

      if (user && user.domains) {
        for (let i = 0; i < user.domains.length; i++) {
          $scope.domains.push(user.domains[i]);
        }
      }
      if ($scope.banner_id) {
        $scope.getBannerAndStore($scope.banner_id);
      }
    };

    $scope.getBannerAndStore = (banner_id) => {
      $scope.loading = true;
      bannerNotificationsService.getOne(banner_id).then((data) => {
        $scope.formData = _.pick(data, [
          'start_date',
          'end_date',
          'message',
          'theme',
          'subdomains',
          'dismissible',
          'is_global',
        ]);
        $scope.formData.start_date = tzService.parseUserDate($scope.formData.start_date);
        $scope.formData.end_date = tzService.parseUserDate($scope.formData.end_date);
        $scope.loading = false;
      });
    };

    $scope.submit = (form) => {
      // console.log(form, $scope.formData);
      // return;
      $scope.processing = true;

      $scope.data.alerts = [];

      if ($scope.formData.is_global) {
        $scope.formData.subdomains = [];
      }

      const noSubdomainsSelectedError = !$scope.formData.subdomains.length && !$scope.formData.is_global;
      if (form.$invalid || noSubdomainsSelectedError) {
        $scope.createAlert(
          `<span class="fa fa-exclamation-triangle"></span> ${$translate
            .instant('common.check_form_for_errors')
            .toString()}`,
          'danger',
        );
        $scope.processing = false;
      } else if ($scope.banner_id) {
        bannerNotificationsService
          .update($scope.banner_id, $scope.formData)
          .then(() => {
            $scope.createAlert(
              `<span class="fa fa-check"></span> ${$translate
                .instant('banner.create_or_update.update_success')
                .toString()}`,
              'success',
              2500,
            );
            bannerNotificationsService.getBannersAndCache();
            $state.go('v1.banners');
          })
          .catch((data) => {
            $scope.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> ${$translate
                .instant('banner.create_or_update.failure')
                .toString()} ${angular.toJson(data)}`,
              'danger',
            );
          })
          .finally(() => {
            $scope.processing = false;
          });
      } else {
        bannerNotificationsService
          .add($scope.formData)
          .then(() => {
            $scope.createAlert(
              `<span class="fa fa-check"></span> ${$translate
                .instant('banner.create_or_update.create_success')
                .toString()}`,
              'success',
              2500,
            );
            bannerNotificationsService.getBannersAndCache();
            $state.go('v1.banners');
          })
          .catch((data) => {
            $scope.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> ${$translate
                .instant('banner.create_or_update.failure')
                .toString()} ${angular.toJson(data)}`,
              'danger',
            );
          })
          .finally(() => {
            $scope.processing = false;
          });
      }
    };

    $scope.createAlert = (msg, type, timeout) => {
      $scope.data.alerts = [];
      $scope.data.alerts.push({
        msg,
        type,
      });
      if (timeout) {
        $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, timeout);
      }
    };

    $scope.initialize();
  },
]);
